export default __webpack_public_path__ + "static/home-3550ab3ded9cc3b125b7b8125761e06a.webp";